/* MCR · cart upsell (drawer + cart page). <mcr-cart-upsell data-product-id data-exclude data-limit>
   Fetches /recommendations/products.json (complementary → related fallback), renders mini cards and
   adds to cart via /cart/add.js, then refreshes the drawer / cart page through Dawn's own contracts. */
(function () {
  'use strict';
  if (customElements.get('mcr-cart-upsell')) return;
  var cache = new Map();
  var cfg = window.MCRConfig || {};

  function formatMoney(cents) {
    var format = cfg.moneyFormat || '₹{{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var dec = key.indexOf('no_decimals') > -1 ? 0 : 2;
    var comma = key.indexOf('comma_separator') > -1;
    var n = (cents / 100).toFixed(dec).split('.');
    var whole = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (comma ? '.' : ','));
    var val = whole + (n[1] ? (comma ? ',' : '.') + n[1] : '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function fetchReco(root, id, limit, intent) {
    var key = id + ':' + intent + ':' + limit;
    if (cache.has(key)) return cache.get(key);
    var p = fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=' + limit + '&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
    cache.set(key, p);
    return p;
  }

  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function refreshCartPage() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (!items) { window.location.reload(); return; }
    var map = [[items, items.dataset.id], [footer, footer && footer.dataset.id]].filter(function (x) { return x[0] && x[1]; });
    var ids = map.map(function (x) { return x[1]; }).concat(['cart-icon-bubble']);
    var url = (window.routes && window.routes.cart_url) || '/cart';
    fetch(url + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (s) {
        map.forEach(function (x) {
          var html = new DOMParser().parseFromString(s[x[1]] || '', 'text/html');
          var src = html.querySelector('.js-contents');
          var dst = x[0].querySelector('.js-contents');
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var d = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (d) bubble.innerHTML = d.innerHTML;
        }
        document.querySelectorAll('.is-empty').forEach(function (el) {
          if (el.matches('cart-items, #main-cart-footer')) el.classList.remove('is-empty');
        });
      })
      .catch(function () { window.location.reload(); });
  }

  class MCRCartUpsell extends HTMLElement {
    connectedCallback() {
      if (this.__done) return;
      this.__done = true;
      var self = this;
      var root = this.dataset.root || '/';
      if (root.slice(-1) !== '/') root += '/';
      this.root = root;
      var id = this.dataset.productId;
      var limit = parseInt(this.dataset.limit, 10) || 4;
      var exclude = (this.dataset.exclude || '').split(',').filter(Boolean).map(Number);
      if (!id) return;
      var run = function () {
        fetchReco(root, id, limit + exclude.length, 'complementary')
          .then(function (list) {
            list = list.filter(function (p) { return p.available && exclude.indexOf(p.id) === -1; });
            if (list.length) return list;
            return fetchReco(root, id, limit + exclude.length, 'related').then(function (l2) {
              return l2.filter(function (p) { return p.available && exclude.indexOf(p.id) === -1; });
            });
          })
          .then(function (list) { self.render(list.slice(0, limit)); });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 1500 });
      else setTimeout(run, 150);
    }

    render(products) {
      var list = this.querySelector('[data-mcr-cu-list]');
      if (!list || !products.length) return;
      var addLabel = this.dataset.addLabel || 'Add';
      var self = this;
      list.innerHTML = '';
      products.forEach(function (p) {
        var li = document.createElement('li');
        li.className = 'mcr-cu__item';
        var available = (p.variants || []).filter(function (v) { return v.available; });
        var first = available[0] || (p.variants || [])[0];
        if (!first) return;

        var media = document.createElement('a');
        media.className = 'mcr-cu__media';
        media.href = p.url;
        media.tabIndex = -1;
        media.setAttribute('aria-hidden', 'true');
        if (p.featured_image) {
          var im = document.createElement('img');
          im.src = img(p.featured_image, 160);
          im.alt = '';
          im.loading = 'lazy';
          im.width = 80;
          im.height = 100;
          media.appendChild(im);
        }
        var info = document.createElement('div');
        info.className = 'mcr-cu__info';
        var title = document.createElement('a');
        title.className = 'mcr-cu__title';
        title.href = p.url;
        title.textContent = p.title;
        var price = document.createElement('span');
        price.className = 'mcr-cu__price';
        price.textContent = formatMoney(first.price);
        info.appendChild(title);
        info.appendChild(price);

        var select = null;
        if (available.length > 1) {
          select = document.createElement('select');
          select.className = 'mcr-cu__select';
          select.setAttribute('aria-label', p.title);
          available.forEach(function (v) {
            var o = document.createElement('option');
            o.value = v.id;
            o.textContent = v.title;
            o.dataset.price = v.price;
            select.appendChild(o);
          });
          select.addEventListener('change', function () {
            price.textContent = formatMoney(+select.options[select.selectedIndex].dataset.price);
          });
          info.appendChild(select);
        }
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mcr-cu__add';
        btn.textContent = addLabel;
        btn.setAttribute('aria-label', addLabel + ' – ' + p.title);
        btn.addEventListener('click', function () {
          self.add(select ? select.value : first.id, btn);
        });
        li.appendChild(media);
        li.appendChild(info);
        li.appendChild(btn);
        list.appendChild(li);
      });
      if (list.children.length) this.hidden = false;
    }

    add(variantId, btn) {
      var drawer = this.closest('cart-drawer');
      var body = { items: [{ id: +variantId, quantity: 1 }] };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      btn.disabled = true;
      btn.classList.add('is-loading');
      fetch(this.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          if (drawer) {
            drawer.renderContents(res);
            if (document.getElementById('main-cart-items')) refreshCartPage();
          } else {
            refreshCartPage();
          }
        })
        .catch(function (e) {
          if (window.MCR && window.MCR.toast) window.MCR.toast(e.message || 'Error');
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    }
  }
  customElements.define('mcr-cart-upsell', MCRCartUpsell);
})();
